<template>
    <v-app class="login-page">
        <v-main class="login-wrapper">

            <!-- Left Pane (Desktop Only) -->
            <div class="login-left">
                <img src="@/assets/image.png" class="bg-image" />
                <img src="@/assets/crowdital_icon.png" class="logo" />
            </div>

            <!-- Right Pane -->
            <div class="login-right">
                <div class="login-form">

                    <!-- Header -->
                    <div class="mb-8">
                        <img src="../assets/crowdital_logo_dark.png" class="logo-img" alt="Crowdital Logo" />
                        <h3 class="text-2xl font-semibold text-gray-900 mt-8">
                            Proceed to add username
                        </h3>
                        <p class="text-gray-400 text-xs mt-2">
                            Enter your birthday and choose a username
                        </p>
                    </div>

                    <!-- Form -->
                    <form @submit.prevent="addUsername" class="w-full space-y-6">

                        <!-- Username -->
                        <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700 text-left">Username</label>
                            <input v-model="username" type="text" required placeholder="e.g john do not include '@'"
                                class="modern-input" />
                        </div>

                        <!-- DOB -->
                        <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700 text-left">Date of birth</label>
                            <input v-model="dob" type="date" required class="modern-input" />
                        </div>

                        <!-- Submit -->
                        <button type="submit" :disabled="loading" class="login-button mb-4">
                            <span v-if="!loading">Proceed <v-icon start>mdi-account-check-outline</v-icon></span>
                            <span v-else>Processing <v-icon start class="spin">mdi-loading</v-icon></span>
                        </button>
                        <p>Or, return to
                            <button type="button" @click="signin"
                                class="text-sm font-medium text-green hover:text-black transition-colors">
                                Login
                            </button>
                        </p>
                    </form>
                    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
                        snackbar.message }}
                        <template #actions>
                            <v-btn variant="text" @click="snackbar.show = false">
                                Close
                            </v-btn>
                        </template>
                    </v-snackbar>
                </div>
            </div>

        </v-main>
    </v-app>
</template>

<script setup>
import { ref } from "vue"
import { useRouter, useRoute } from "vue-router"
import { addmore } from "@/api/auth"
import { getAllErrors } from "@/util"
//import { useUserStore } from "@/store/user"

const router = useRouter()
const route = useRoute()
//const user = useUserStore()

const dob = ref("")
const username = ref("")
const error = ref("")
const loading = ref(false)
//const email = ref(user.email)

//Snack bar
const snackbar = ref({
    show: false,
    message: "",
    color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
    snackbar.value.message = message
    snackbar.value.color = color
    snackbar.value.show = true
}

const addUsername = async () => {
    error.value = ""
    loading.value = true
    try {
        const res = await addmore({
            email: route.query.email,
            dob: dob.value,
            username: username.value.trim()
        })
        // SUCCESS MESSAGE
        console.log(res.data)
        showSnackbar("Username and DOB Added", "success")

        setTimeout(() => {
            router.push({ name: "Createpin",
                query: {
                    email: route.query.email
                }
             })
        }, 1000) // 0.8s delay
    } catch (e) {
        const msg = getAllErrors(e)
        //console.log(e.response?.data)
        showSnackbar(
            msg || "Signup failed",
            "error"
        )
        error.value = e.response?.data?.message || "Login failed"; //e.message || "Invalid credentials"
    } finally {
        loading.value = false
    }
}

const signin = () => {
    router.push("/login")
}
</script>

<style scoped>
/* Layout */
.login-wrapper {
    display: flex;
    min-height: 100vh;
}

.login-left {
    flex: 1;
    position: relative;
    overflow: hidden;
}

.bg-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.logo-img {
    width: 20em;
}

.logo {
    position: absolute;
    bottom: 24px;
    left: 24px;
    width: 130px;
}

.login-right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f9fafb;
    padding: 24px;
}

.login-form {
    width: 100%;
    max-width: 420px;
}

/* Inputs */
.modern-input {
    width: 100%;
    height: 46px;
    margin-top: 6px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 15px;
    background: transparent;
    transition: all 0.2s ease;
}

.modern-input:focus {
    outline: none;
    border-color: #000;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

/* Button */
.login-button {
    width: 100%;
    height: 46px;
    background: #000;
    color: #fff;
    border-radius: 10px;
    font-weight: 600;
    transition: all 0.25s ease;
}

.login-button:hover {
    background: #292828;
}

.login-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.spacing {
    margin-bottom: 1em;
}

.m-space {
    margin-left: 9.5rem !important;
}

.modern-input.pr-10 {
    padding-right: 2.5rem;
    /* enough space for eye button */
}

.relative {
    position: relative;
}

/* Button positioned over the input */
.absolute {
    position: absolute;
    cursor: pointer;
}
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Mobile */
@media (max-width: 767px) {
    .login-wrapper {
        flex-direction: column;
    }

    .login-left {
        display: none;
    }

    .m-space {
        margin-left: 7rem !important;
    }
}
</style>
